















import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'

export default defineClassComponent(
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()
    },
)
